// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__znQVZ"};